import { toast } from "react-hot-toast";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./CertificateToast.module.css";
import Icon from "@/ui/icon/Icon";

import Svg1 from "@/assets/images/certificates/1.svg";

// `toastState` is react-hot-toast's own object for this toast.
function CertificateToastContent({
	t: toastState,
	certificateID,
	img,
	navigate,
}) {
	const { t } = useTranslation();
	const duration = 10000;
	const [progress, setProgress] = useState(100);

	useEffect(() => {
		const interval = setInterval(() => {
			setProgress((prev) => {
				const newProgress = prev - 100 / (duration / 100);
				if (newProgress <= 0) {
					clearInterval(interval);
					toast.dismiss(toastState.id);
					return 0;
				}
				return newProgress;
			});
		}, 100);

		return () => clearInterval(interval);
	}, [toastState.id, duration]);

	return (
		<div
			className={`${style.body} ${
				toastState.visible ? style.enter : style.leave
			} `}
		>
			<div className={style.imgHolder}>
				<img
					src={img || Svg1}
					alt={t("courses:certificate.toast.imageAlt")}
				/>
			</div>
			<div className={style.info}>
				<div className={style.header}>
					<div className={style.title}>
						<Icon icon="fa-seal" />
						<h3>{t("courses:certificate.toast.title")}</h3>
					</div>
					<p>{t("courses:certificate.toast.text")}</p>
				</div>
				<div className={style.buttonsHolder}>
					<button
						onClick={() => {
							toast.dismiss(toastState.id);
							navigate &&
								navigate(`/certificates/${certificateID}`);
						}}
						className={style.btn}
					>
						{t("courses:certificate.toast.open")}
					</button>
					<button
						onClick={() => toast.dismiss(toastState.id)}
						className={style.close}
					>
						{t("common:actions.close")}
					</button>
				</div>
			</div>
			<div className={style.progress}>
				<div
					className={style.line}
					style={{
						width: `${progress}%`,
					}}
				></div>
			</div>
		</div>
	);
}

function certificateToast(certificateID, img, navigate) {
	const duration = 10000;

	toast.custom(
		(t) => (
			<CertificateToastContent
				t={t}
				certificateID={certificateID}
				img={img}
				navigate={navigate}
			/>
		),
		{ duration: duration }
	);
}

export default certificateToast;
